"use strict";

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function help(_ref) {
  var commandService = _ref.commandService;

  var listAll = function listAll() {
    return Object.keys(commandService.registry).sort();
  };

  var listOne = function listOne(commandName) {
    var command = commandService.registry[commandName];

    if (command) {
      var name = command.name,
          _command$synopsis = command.synopsis,
          synopsis = _command$synopsis === void 0 ? none : _command$synopsis,
          _command$description = command.description,
          description = _command$description === void 0 ? none : _command$description,
          _command$options = command.options,
          options = _command$options === void 0 ? {} : _command$options;

      var formatOption = function formatOption(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            _ref3$ = _ref3[1],
            alias = _ref3$.alias,
            type = _ref3$.type,
            def = _ref3$.default,
            _ref3$$required = _ref3$.required,
            required = _ref3$$required === void 0 ? false : _ref3$$required,
            _ref3$$description = _ref3$.description,
            describe = _ref3$$description === void 0 ? none : _ref3$$description;

        var keyDescriptor = "-".concat(key, ", --").concat(alias);
        var typeDescriptor = "[".concat([type, def ? ":".concat(def) : null, required ? 'REQUIRED' : null].filter(function (i) {
          return i;
        }).join(' '), "]");
        return "".concat(keyDescriptor, "\t").concat(typeDescriptor, "\t").concat(describe);
      };

      var optsString = Object.entries(options).map(formatOption).join('\n');
      return "\nNAME\n      ".concat(name, "\n\nSYNOPSIS\n      ").concat(synopsis || none, "\n\nDESCRIPTION\n      ").concat(description || none, "\n\nOPTIONS\n      ").concat(optsString || none, "\n");
    }
  };

  return {
    name: 'help',
    synopsis: 'help ?[COMMAND]',
    description: 'List all available commands and help dialog for an individual command',
    execute: function execute(args) {
      switch (args.length) {
        case 0:
          return listAll();

        case 1:
          {
            var _args = _slicedToArray(args, 1),
                command = _args[0];

            var description = listOne(command);

            if (!description) {
              throw new Error("Unknown command \"".concat(command, "\""));
            }

            return listOne(args[0]);
          }

        default:
          throw new Error('Wrong number of arguments: expected 0 or 1');
      }
    },
    format: function format(output) {
      if (Array.isArray(output)) {
        // list all
        return ['Available Commands', '------------------'].concat(_toConsumableArray(output)).join('\n');
      }

      return output;
    }
  };
}

var none = '(none)';
var _default = help;
exports.default = _default;